import BasePage from "@Scripts/Pages/BasePage";
import Localizer from "@Scripts/Common/Localizer";

export default class NewPartsPage extends BasePage {
    public static async init() {
        await super.init();

        this.setShowButton();
    }

    private static setShowButton() {
        var localizer: any = Localizer;

        let buttons = document.querySelectorAll(".button.test");
        for (const button of buttons) {
            button.addEventListener("click", x => {
                var dataType = button.getAttribute("data-type");
                var dataShow = button.getAttribute("data-show");

                if (dataShow == "false") {
                    let rows = document.querySelectorAll(".row.exp[data-type=" + dataType + "]");
                    rows.forEach(y => { y.classList.remove("hden"); });

                    button.setAttribute("data-show", "true");
                    button.textContent = localizer.get("App.NewParts.CloseCodes");
                } else {
                    let rows = document.querySelectorAll(".row.exp[data-type=" + dataType + "]");
                    rows.forEach(y => { y.classList.add("hden"); });

                    button.setAttribute("data-show", "false");
                    button.textContent = localizer.get("App.NewParts.ShowAllCodes");
                }
            })
        }
    }
}